<template>
  <div>
    <div
      class="row small-collapse"
      :class="{ 'formValidation-shake': isShake }"
    >
      <h2>{{ title }}</h2>
      <p>{{ intro }}</p>

      <input
        v-show="this.iAmA == 'individual'"
        type="button"
        value="Here's the message we're sending"
        v-on:click="openReadLetterPage"
        class="read-letter"
      />

      <div class="small-6 columns left-field">
        <label for="firstName">
          First name
          <input
            type="text"
            name="firstName"
            id="firstName"
            v-model="lead.firstName"
            v-validate="'required'"
            :class="{ 'border-red': errors.has('firstName') }"
            data-vv-as="first name"
            v-on:focus="logFirstTouch('first name')"
            v-on:blur="logProvided('Fname provided', lead.firstName)"
          />
          <span class="form-error-area" v-if="errors.first('firstName')">
            <p>{{ errors.first("firstName") }}</p>
          </span>
        </label>
      </div>
      <div class="small-6 columns right-field">
        <label for="lastName">
          Last name
          <input
            type="text"
            name="lastName"
            id="lastName"
            v-model="lead.lastName"
            v-validate="'required'"
            :class="{ 'border-red': errors.has('lastName') }"
            data-vv-as="last name"
            v-on:focus="logFirstTouch('last name')"
            v-on:blur="logProvided('Lname provided', lead.lastName)"
          />
          <span class="form-error-area" v-if="errors.first('lastName')">
            <p>{{ errors.first("lastName") }}</p>
          </span>
        </label>
      </div>
      <div class="small-6 left-field columns">
        <label for="email">
          Email
          <div class="with-input-loading">
            <input
              type="email"
              name="email"
              id="email"
              v-model="lead.email"
              v-validate="{
                required: true,
                earthhourEmailIsValid: true,
                email: true,
              }"
              :class="{ 'border-red': errors.has('email') }"
              data-vv-as="email"
              @input="onEmailInput()"
              v-on:focus="logFirstTouch('email')"
              v-on:blur="logProvided('Email provided', lead.email)"
            />
            <div
              class="input-loading"
              v-if="
                emailCheckSensis.checkEmailLoading ||
                emailCheckDuplicate.checkEmailLoading
              "
            >
              <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3505/dist/assets/img/loading-tail-spin.svg" />
            </div>
            <span class="form-error-area" v-if="errors.first('email')">
              <p>{{ errors.first("email") }}</p>
            </span>
          </div>
        </label>
      </div>
      <div class="small-6 right-field columns">
        <label for="phone">
          Phone
          <input
            type="tel"
            name="phone"
            id="phone"
            v-validate="{ required: true, earthhourPhoneNumberIsValid: true }"
            v-model="lead.phone"
            :class="{
              'border-red':
                errors.has('phone') ||
                errors.has('earthhourPhoneNumberIsValid'),
            }"
            data-vv-as="phone"
            v-on:focus="logFirstTouch('phone')"
            v-on:blur="logProvided('Phone provided', lead.phone)"
          />
          <span class="form-error-area" v-if="errors.first('phone')">
            <p>{{ errors.first("phone") }}</p>
          </span>
        </label>
      </div>
      <div class="small-6 columns left-field">
        <label for="postcode">
          Postcode
          <input
            type="tel"
            name="postcode"
            id="postcode"
            v-validate="'required|numeric'"
            v-model="lead.postCode"
            :class="{ 'border-red': errors.has('postcode') }"
            data-vv-as="postcode"
            v-on:focus="logFirstTouch('postcode')"
            v-on:blur="logFilled('Post code', lead.postCode)"
          />
          <span class="form-error-area" v-if="errors.first('postcode')">
            <p>{{ errors.first("postcode") }}</p>
          </span>
        </label>
      </div>

      <!-- IAmA -->
      <div class="small-6 columns right-field">
        <label for="iAmA">
          I am {{ iAmA == "individual" || iAmA == "organisation" ? "an" : "a" }}
          <select
            name="iAmA"
            v-model="iAmA"
            v-validate="'required'"
            :class="{ 'border-red': errors.has('iAmA') }"
            data-vv-as="I am"
            v-on:change="removeImage"
            v-on:focus="logFirstTouch('iAmA')"
            v-on:blur="logFilled('User category', iAmA)"
          >
            <option value disabled selected>Select</option>
            <option value="individual">Individual</option>
            <option value="school">School</option>
            <option value="council">Council</option>
            <option value="business">Business</option>
            <option value="landmark">Landmark</option>
            <option value="organisation">Organisation</option>
          </select>
          <span class="form-error-area" v-if="errors.first('iAmA')">
            <p>{{ errors.first("iAmA") }}</p>
          </span>
        </label>
      </div>

      <div
        class="small-12 columns"
        v-if="showCompetition && iAmA && iAmA == 'individual'"
      >
        <div checked="checked" class="wwf-checkbox">
          <label>
            <input
              type="checkbox"
              id="in-competition"
              name="in-competition"
              v-model="isInCompetition"
            />
            <span class="checkbox"></span>
            {{ competitionText }}
          </label>
        </div>
      </div>

      <div
        class="small-12 columns"
        v-if="showCompetition && iAmA && iAmA == 'individual'"
      >
        <div checked="checked" class="wwf-checkbox">
          <label>
            <input
              type="checkbox"
              id="accept-contact-From-Partner"
              name="accept-contact-from-Partner"
              v-model="acceptContactFromPartner"
            />
            <span class="checkbox"></span>
            {{ partnerOptinLabel }}
          </label>
        </div>
      </div>

      <div class="small-12 columns" v-if="iAmA && iAmA != 'individual'">
        <!-- Name of IAmA -->
        <label for="othername">
          Name of the {{ iAmA }}
          <input
            type="text"
            name="othername"
            id="othername"
            v-model="othername"
            v-validate="'required'"
            :class="{ 'border-red': errors.has('othername') }"
            :data-vv-as="'name of the ' + this.iAmA"
            v-on:focus="logFirstTouch('othername')"
            v-on:blur="logProvided('Oname provided', othername)"
          />
          <span class="form-error-area" v-if="errors.first('othername')">
            <p>{{ errors.first("othername") }}</p>
          </span>
        </label>

        <!-- File Upload -->
        <label for="logoInput">
          Upload your logo here (Not mandatory)

          <!-- Max size: 1Mb -->
          <input
            type="file"
            name="logoInput"
            id="logoInput"
            :size="fileUpload.maxSize"
            accept=".png, .jpg, .jpeg, .gif"
            :disabled="isSaving"
            ref="logoInput"
            @change="filesChange($event.target.files)"
            v-on:focus="logFirstTouch('logo')"
          />
          <label class="file-label" for="logoInput">
            <span v-if="isClean">
              <i class="fas fa-file"></i> Choose a file... (Max 1Mb)
            </span>
            <span v-if="!isClean">{{ fileUpload.fileName }} selected... </span>
            <span class="alert-box" v-if="hasError">
              {{ fileUpload.error }}
            </span>
          </label>
        </label>
        <div class="preview-container" v-if="!isClean && fileUpload.source">
          <div class="img-delete">
            <button type="button" v-on:click="removeImage">
              <i class="fas fa-times fw"></i>
            </button>
          </div>
          <img class="preview-image" :src="fileUpload.source" />
        </div>
      </div>

      <!-- Bad words Alert -->
      <div class="small-12 columns" v-show="isProfanity">
        <span class="alert-box"> No bad words! Please change your name. </span>
      </div>

      <!-- Submit -->
      <div class="clear">
        <div class="submit-bttn bttn-lrg">
          <input
            type="button"
            :value="!isSaving ? buttontitle : 'Loading...'"
            v-on:click="save"
          />
        </div>
      </div>

      <!-- Counter -->
      <div class="small-12 columns counter-area" v-if="showcounter">
        <h2>
          <count-to
            ref="counter"
            :startVal="startcounter"
            :end-val="endcounter"
            :autoplay="false"
            :duration="7000"
          ></count-to>
        </h2>
        <h5>{{ countertitle }}</h5>
      </div>
    </div>
    <div class="privacy-statement">
      <p>
        By signing you accept
        <a href="/privacy-policy/privacy-policy" target="_blank">
          WWF-Australia’s Privacy Policy.
        </a>
      </p>
      <p v-if="showCompetition && iAmA && iAmA == 'individual'">
        Read the competiton
        <a :href="competitionPrivacyPolicy" target="_blank">
          Terms and Conditions.
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import countTo from "vue-count-to";
import moment from "moment";
import { mapState } from "vuex";
import { getParameterByName } from "../../helpers";
import gtm from "../../utils/gtm";
import firebase from "firebase";

export default {
  name: "EarthhourRegistration",
  components: { countTo },
  created: async function () {
    // Get the query param for the popup
    this.queryParam = getParameterByName("su");

    // Subscribe to real-time counter
    if (this.showcounter) {
      this.subscriptions.push(
        await firebase
          .firestore()
          .collection("campaigns")
          .doc(this.datalayername)
          .onSnapshot(
            (snapshot) => {
              const data = snapshot.data();
              if (!!data) {
                this.setCounter(data.count);
              }
            },
            (error) => {
              console.error(err);
            }
          )
      );
    }

    // Check the email
    let earthhourEmailIsValid = (email) => {
      return new Promise((resolve, reject) => {
        this.errors.remove("email");
        Promise.all([this.checkEmailDuplicate(), this.checkEmail()])
          .then((results) => {
            for (const r of results) {
              if (!r.valid) {
                return resolve(r);
              }
            }
            this.errors.remove("email");
            resolve({ valid: true });
          })
          .catch((err) => {
            console.error(err);
            this.errors.remove("email");
            resolve({ valid: true });
          });
      });
    };

    Validator.extend("earthhourEmailIsValid", {
      validate: earthhourEmailIsValid,
      getMessage: (field, params, data) => data.message,
    });

    // Check Phone Number
    let earthhourPhoneNumberIsValid = (phone) => {
      const validationRegex = /^(\+?61|0)([0-9]{8,9})/;
      if (!phone.replace(/ /g, "").match(validationRegex)) {
        return {
          valid: false,
          field: "phone",
          data: { message: "Invalid phone number" },
        };
      } else {
        return {
          valid: true,
        };
      }
    };

    Validator.extend("earthhourPhoneNumberIsValid", {
      validate: earthhourPhoneNumberIsValid,
      getMessage: (field, params, data) => data.message,
    });
  },
  beforeDestroy: function () {
    // Unsubscript from all subscriptions
    for (const s of this.subscriptions) {
      s();
    }
  },
  mounted: function () {
    if (this.showcounter && this.$refs.counter) {
      this.$refs.counter.start();
    }
  },
  computed: {
    endcounter() {
      return this.$store.getters.counter ? this.$store.getters.counter : 1;
    },
    isClean() {
      return !this.fileUpload.fileName || this.fileUpload.fileName.length === 0;
    },
    hasError() {
      return this.fileUpload.error != null;
    },

    ...mapState({
      lead: (state) => state.earthHour,
      user: (state) => state.auth.user,
    }),
  },
  watch: {
    // use the watch to react on the value change.
    endcounter(newValue) {
      if (this.showcounter) {
        this.startcounter = newValue;
        this.$refs.counter.start();
      }
    },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    intro: {
      type: String,
      required: true,
    },
    datalayername: {
      type: String,
      required: true,
    },
    programname: {
      type: String,
      required: true,
    },
    showcounter: {
      type: Boolean,
      default: true,
    },
    countertitle: {
      type: String,
      default: "message sent",
    },
    buttontitle: {
      type: String,
      default: "Submit",
    },
    keepData: {
      type: Boolean,
      required: false,
      default: false,
    },
    iAmADefault: {
      type: String,
      default: "individual",
    },
    competitionText: {
      type: String,
      default: "Enter the competition to win an electric scooter",
    },
    showCompetition: {
      type: Boolean,
      default: false,
    },
    competitionPrivacyPolicy: {
      type: String,
      default: "/terms-and-conditions",
    },
    partnerOptinLabel: {
      type: String,
      default: "Receive inspiration and special offers from Intrepid Travel",
    },
  },
  data() {
    return {
      formTouched: false,
      iAmAProvided: false,
      startcounter: 1,
      othername: null,
      isSaving: false,
      isProfanity: false,
      error: false,
      isShake: false,
      iAmA: this.iAmADefault,
      isInCompetition: true,
      acceptContactFromPartner: false,
      queryParam: null,
      extensions: [".png", ".jpg", ".jpeg", ".gif"],
      subscriptions: [],
      emailCheckSensis: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/,
      },
      emailCheckDuplicate: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/,
      },
      fileUpload: {
        fileUploaded: null,
        fileName: "",
        error: null,
        maxSize: 1000000,
        source: null,
      },
    };
  },
  methods: {
    setCounter(value) {
      this.$store.commit("setCounter", value);
    },
    filesChange(fileList) {
      try {
        if (!fileList.length) return;
        const file = fileList[0];

        if (file.size <= this.fileUpload.maxSize) {
          // Check extension of the file
          const dotIndex = file.name.lastIndexOf(".");

          if (dotIndex < 0) {
            this.fileUpload.error = "File name is missing extension";
            return;
          }

          const extension = file.name.substring(dotIndex).toLowerCase();
          if (!this.extensions.includes(extension)) {
            this.fileUpload.error =
              "Please use only these formats: .png, .jpg, jpeg, .gif";
            return;
          }

          this.logFilled("Upload Logo", true);

          this.fileUpload.fileName = file.name;
          this.fileUpload.fileUploaded = file;
          this.fileUpload.error = null;

          // Allow to preview
          const reader = new FileReader();
          reader.onload = (e) => {
            this.fileUpload.source = e.target.result;
          };
          reader.readAsDataURL(file); // convert to base64 string
        } else {
          this.fileUpload.error = "File too big!";
        }
      } catch (err) {
        this.fileUpload.error = "Cannot read the file, please try another one.";
      }
    },
    removeImage() {
      // Give the time to the dom to render (When coming from individual to other)
      setTimeout(() => {
        if (this.$refs.logoInput) this.$refs.logoInput.value = "";
        this.fileUpload.fileName = "";
        this.fileUpload.fileUploaded = null;
      }, 10);
    },
    openReadLetterPage: function () {
      this.$store.commit("openLetterPopup", true);
    },
    onEmailInput: function () {
      if (this.emailCheckDuplicate.timeout) {
        clearTimeout(this.emailCheckDuplicate.timeout);
        this.emailCheckDuplicate.timeout = null;
      }

      // Only call if not input for 500 ms
      this.emailCheckDuplicate.timeout = setTimeout(() => {
        this.checkEmailDuplicate()
          .then((result) => {
            if (!result.valid) {
              this.errors.add({
                field: "email",
                msg: "Your email has already been submitted",
              });
            }
          })
          .catch((err) => {
            // If it fails, let the user free to continue
            console.error(err);
          });
      }, 500);
    },
    checkEmailDuplicate: function () {
      return new Promise((resolve, reject) => {
        let timestamp = Date.now(); // timestamp for this api call
        this.emailCheckDuplicate.lastTimestamp = timestamp; // 1 , 2 , 3
        this.emailCheckDuplicate.checkEmailLoading = true;
        // Fetch Suggestions
        this.$store
          .dispatch("checkEmail", {
            campaignId: this.datalayername,
            email: this.lead.email,
          })
          .then((result) => {
            if (timestamp >= this.emailCheckDuplicate.lastTimestamp) {
              if (result) {
                resolve({
                  valid: false,
                  field: "email",
                  data: { message: "Your email has already been submitted" },
                });
              } else {
                resolve({ valid: true });
              }
            }
            this.emailCheckDuplicate.checkEmailLoading = false;
          })
          .catch((err) => {
            console.error(err);
            this.emailCheckDuplicate.checkEmailLoading = false;
            // If it fails, let the user free to continue
            resolve({ valid: true });
          });
      });
    },
    checkEmail: function () {
      return new Promise((resolve, reject) => {
        let timestamp = Date.now(); // timestamp for this api call
        this.emailCheckSensis.lastTimestamp = timestamp; // 1 , 2 , 3
        this.emailCheckSensis.checkEmailLoading = true;
        // Fetch Suggestions
        this.$store
          .dispatch("validateEmail", this.lead.email)
          .then((response) => {
            if (response && timestamp >= this.emailCheckSensis.lastTimestamp) {
              this.emailCheckSensis.checkEmailLoading = false;
              resolve(response);
            }
          })
          .catch((err) => {
            console.error(err);
            this.emailCheckSensis.checkEmailLoading = false;
            // If it fails, let the user free to continue
            resolve({ valid: true });
          });
      });
    },
    save: function () {
      // Exit function if already saving
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      // Create post body
      const postBody = {
        email: this.lead.email,
        firstName: this.lead.firstName,
        lastName: this.lead.lastName,
        postcode: this.lead.postCode,
        phone: this.lead.phone,
        programName: this.programname,
        iAmA: this.iAmA,
        other: this.othername,
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: this.keepData,
        ssoId: this.$store.getters.ssoId,
        sourceUrl: window.location.href,
      };

      if (this.iAmA === "individual") {
        postBody.isInCompetition = this.isInCompetition;
        postBody.acceptContactFromPartner = this.acceptContactFromPartner;
      }
      console.log("postBody", postBody);

      // Purify the inputs
      this.$validator.validate().then(async (result) => {
        if (result) {
          const results = await Promise.all([
            this.$store.dispatch("purifyText", postBody.firstName),
            this.$store.dispatch("purifyText", postBody.lastName),
          ]);

          const inError = results.filter((e) => e === false);
          const isPure = inError.length === 0;
          this.isProfanity = !isPure;

          if (isPure) {
            if (!this.iAmAProvided) {
              this.logFilled("User category", this.iAmA);
            }

            // Save logo if uploaded
            if (this.fileUpload.fileUploaded && this.iAmA != "individual") {
              await this.saveLogo();
            }

            // Save lead
            await this.$store.dispatch("saveLead", {
              campaignId: this.datalayername,
              lead: postBody,
            });

            // Log step to Amplitude
            this.$store.dispatch("logPetitionComplete", {
              id: window.location.pathname,
              count: this.startcounter,
            });

            // GTM Tracking
            const formName =
              this.datalayername + (this.iAmA != "individual" ? "-others" : "");
            gtm.formSubmitSuccessEvent(formName);

            // Reset form
            this.lead.firstName = "";
            this.lead.lastName = "";
            this.lead.email = "";
            this.lead.phone = "";
            this.lead.postCode = "";
            this.iAmA = this.iAmADefault;
            this.othername = "";
            this.isSaving = false;
            this.isInCompetition = false;
            this.acceptContactFromPartner = false;

            this.fileUpload.error = null;

            // Reset errors
            this.$validator.errors.clear();

            // Create Popup
            this.earthHourPopup(postBody);
          } else {
            this.formInvalid();
          }
        } else {
          this.formInvalid();
        }
      });
    },
    formInvalid: function () {
      console.log("form invalid");
      // GTM Tracking
      gtm.formSubmitEvent(this.datalayerName);
      this.isSaving = false;
      this.isShake = true;

      setTimeout(
        function () {
          this.isShake = false;
        }.bind(this),
        500
      );
    },
    saveLogo: async function () {
      console.log("Uploading file");

      // Upload the logo
      const formData = new FormData();
      formData.append(
        "organisation-logo",
        this.fileUpload.fileUploaded,
        this.fileUpload.fileName
      );
      const url = await this.$store.dispatch("uploadEarthhourLogo", {
        file: formData,
        organisationName: this.othername,
      });

      // Save the meta data to be reviewed
      const meta = {
        date: moment().format("DD-MM-YYYY"),
        senderEmail: this.lead.email,
        firstName: this.lead.firstName,
        lastName: this.lead.lastName,
        section: this.iAmA,
        organisationName: this.othername,
        imageSize: this.fileUpload.fileUploaded.size,
        url,
      };

      await this.$store.dispatch("createEarthhourLogo", meta);

      // Remove the image after uploading
      this.removeImage();
      console.log("File Uploaded");
    },
    earthHourPopup: function (postBody) {
      if (
        postBody.iAmA !== "individual" &&
        postBody.iAmA !== "business" &&
        postBody.iAmA !== "school"
      ) {
        postBody.iAmA = "community";
      }
      this.$store.commit("setIAmA", postBody.iAmA);

      // Log Popup to Amplitude
      this.$store.dispatch("logEarthHourPopup", {
        name: "pop-up viewed",
      });

      this.$store.commit("openEarthHourPopup", true);
    },
    logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logEarthHourStart", {
          fieldName,
          productName: this.programname,
        });
        this.formTouched = true;
      }
    },
    logProvided(fieldName, content) {
      if (content && content.length > 0) {
        this.$store.dispatch("logEarthHourDetails", {
          fieldName,
          content: true,
        });
      }
    },
    logFilled(fieldName, content) {
      if (fieldName === "User category") this.iAmAProvided = true;
      this.$store.dispatch("logEarthHourDetails", {
        fieldName,
        content,
        productName: this.programname,
      });
    },
  },
};
</script>

<style scoped>
.clear {
  clear: both;
}

.wwf-checkbox {
  margin-top: 15px;
}

.input-loading {
  top: 3px;
}

.submit-bttn {
  margin-top: 16px;
}

input[type="file"] {
  opacity: 0;
  z-index: 15;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  margin-bottom: 0;
  cursor: pointer;
}

.file-label {
  margin-top: 8px;
  padding: 12px;
  border: 2px solid var(--wwfWhite);
  border-radius: 8px;
  cursor: pointer;
}

.light .file-label {
  border: 2px solid var(--wwfBlack);
}

.file-label i {
  margin-right: 6px;
}

.preview-container {
  position: relative;
  margin-top: 8px;
  max-width: 120px;
  max-height: 120px;
}

.preview-container .img-delete {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 4px;
  right: 4px;
  border-radius: 50%;
  background-color: var(--wwfWhite);
  width: 20px;
  height: 20px;
  font-size: 14px;
  cursor: pointer;
}

.preview-container .img-delete i {
  margin: 0;
  cursor: pointer;
}

.preview-image {
  max-width: 120px;
  max-height: 120px;
}

.light .wwf-checkbox label:hover .checkbox::before {
  box-shadow: inset 0 0 0 2px var(--wwfGrey27);
}
</style>







// WEBPACK FOOTER //
// EarthhourRegistration.vue?631077da